module.exports = __webpack_public_path__ + "media/images/recipe-placeholder-4f2573f8.webp";